  @if (mode === 'read') {
    @if (!readonly) {
    <div class="custom-row">
      <div class="mr-2">
        <ppl-button label="Add" icon="fa fa-plus" [customClass]="'ghost-button dialog-btn'" [iconPosition]="'left'"
          (click)="addWaiver()"></ppl-button>
      </div>
    </div>
    }
    <div class="table-style">
      <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="waiverData"
        [disableSelection]="true" [cols]="cols" (gridAction)="action($event)" [gridTitle]="false"
        [pagination]="false" [loadPage]="true" [actionButtons]="actionButtons">
      </ppl-list-table>
    </div>
  } @else {
    <ppl-aor-waiver-form [mode]="mode" [waiverData]="selectedWaiver" (cancel)="cancel($event)"
      (savedWaiver)="savedWaiver($event)"></ppl-aor-waiver-form>
  }
